import { render, staticRenderFns } from "./NoArticle.vue?vue&type=template&id=58de4aab"
import script from "./NoArticle.vue?vue&type=script&lang=js"
export * from "./NoArticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports